import clsx from 'clsx'
import React, { FC } from 'react'

import { Button, ButtonProps } from '@Components/Button'
import { Progress, ProgressProps } from '@Components/Progress'

import styles from './ButtonWithProgress.module.scss'

interface ButtonWithProgressProps extends ButtonProps {
  loading: boolean
  progressClassName?: string
}

const progressColor = (
  buttonColor: ButtonProps['color'],
  buttonVariant: ButtonProps['variant'],
): ProgressProps['color'] => {
  if (buttonVariant === 'outlined') {
    return buttonColor === 'primary' ? 'primary' : 'grey'
  }
  return buttonColor === 'white' ? 'grey' : 'white'
}

const progressSize = (
  buttonSize: ButtonProps['size'],
): ProgressProps['size'] => (buttonSize === 'small' ? 'x-small' : 'small')

export const ButtonWithProgress: FC<ButtonWithProgressProps> = ({
  children,
  className,
  color = 'primary',
  loading = false,
  progressClassName,
  size = 'medium',
  variant = 'full',
  ...props
}: ButtonWithProgressProps) => (
  <div className={clsx(styles.buttonWithProgress, { [styles.loading]: loading }, className)}>
    <Button
      className={className}
      color={color}
      size={size}
      variant={variant}
      {...props}
    >
      {children}
    </Button>
    {loading && (
      <Progress
        center
        className={progressClassName}
        color={progressColor(color, variant)}
        size={progressSize(size)}
      />
    )}
  </div>
)
